'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Col, Container, Row, Spinner } from 'reactstrap';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { MdOutlineEdit } from 'react-icons/md';
import Link from 'next/link';
import { useUser } from '../../contexts/UserContext';
import useWindowWidth from '../../hooks/useWindowWidth';
import capitalizeFirstLetter from '../../utils/capitalizeFirstLetter';
import DashboardHeader from '../../components/mySynergie/dashboard/DashboardHeader';
import DashboardNotifications from '../../components/mySynergie/dashboard/DashboardNotifications';
import DashboardOverview from '../../components/mySynergie/dashboard/DashboardOverview';
import DashboardJobMatches from '../../components/mySynergie/dashboard/DashboardJobMatches';
import AgencyTeaser from '../../components/AgencyTeaser';
import useData from '../../hooks/useData';
import ProfileModal from '../../components/auth/ProfileModal';
import NoAgencyTeaser from '../../components/NoAgencyTeaser';
import { useMySynergieNotifications } from '../../contexts/MySynergieNotificationsContext';
import { saveCandidate } from '../../api/candidate';
import { Dictionaries, Locale } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

type Props = {
  locale: Locale;
  dictionary: Partial<Dictionaries>;
};
const Dashboard = ({ locale, dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { push } = useRouter();
  const { candidate, loading, refetchCandidate } = useUser();

  const searchParams = useSearchParams();
  const profileModalOpen = searchParams.get('profileModal') === 'true';

  const { mySynergieNotifications: notifications } = useMySynergieNotifications();
  const {
    data: jobMatchResponse,
    isLoading: jobMatchesLoading,
    refetchData: refetchJobMatches,
  } = useData<JobMatchResponse>(`/job-matches?maxHits=3`);
  const app = process.env.NEXT_PUBLIC_APP;

  const windowWidth = useWindowWidth();
  const onMobile = windowWidth && windowWidth < 768;

  const toggleProfileModal = async () => {
    if (profileModalOpen) {
      await saveCandidate({ acquaintanceFlowSkipped: true }, 'acquaintance-skip');
      refetchJobMatches();
      refetchCandidate();
      push(`/${locale}/my-synergie`);
    } else push(`/${locale}/my-synergie?profileModal=true`);
  };

  const showEditCta = candidate?.agency && app !== ('werkenbijsynergie.be' || 'travaillezchezsynergie');

  return (
    <div className="mysynergie-dashboard mySynergie">
      {(loading || !candidate) && (
        <div className="d-flex justify-content-center mt-5">
          <Spinner color="primary" size="lg" />
        </div>
      )}
      <ProfileModal dictionary={dictionary} isOpen={profileModalOpen} toggle={toggleProfileModal} />
      {candidate && <DashboardHeader dictionary={dictionary} candidate={candidate} />}
      {!loading && candidate && (
        <Container fluid="lg" className="my-5">
          <Row className="mb-3 mb-md-4">
            <Col xs={{ order: 1, size: 12 }} md={{ order: 3, size: 6 }} className="mb-3 mb-md-0">
              {notifications && (
                <DashboardNotifications dictionary={dictionary} notifications={notifications?.slice(0, onMobile ? 3 : 2)} />
              )}
            </Col>
            <Col xs={{ order: 2, size: 12 }} md={{ order: 1, size: 12 }} className="mb-3 mb-md-4">
              <DashboardOverview dictionary={dictionary} />
            </Col>
            <Col xs={{ order: 3, size: 12 }} md={{ order: 2, size: 6 }} className="mb-3 mb-md-0">
              <section className="mysynergie-dashboard-agency d-flex flex-column h-100">
                <Row>
                  <Col className="d-flex w-100 justify-content-between">
                    <h2 className="mb-3">{capitalizeFirstLetter(formatMessage({ id: 'mysynergie_agency' }))}</h2>
                    {showEditCta && (
                      <Link href={`/${locale}/my-synergie/edit-agency`}>
                        <MdOutlineEdit size={20} />
                      </Link>
                    )}
                  </Col>
                </Row>
                {candidate?.agency ? (
                  <AgencyTeaser
                    locale={locale}
                    dictionary={dictionary}
                    mySynergie
                    agency={candidate?.agency}
                    className="dashboard-agency flex-grow-1 mb-0"
                  />
                ) : (
                  <NoAgencyTeaser dictionary={dictionary} />
                )}
              </section>
            </Col>
          </Row>
          {jobMatchResponse && (
            <DashboardJobMatches dictionary={dictionary} jobMatches={jobMatchResponse} isLoading={jobMatchesLoading} />
          )}
        </Container>
      )}
    </div>
  );
};

export default Dashboard;
